import { render, staticRenderFns } from "./CustomThemes.vue?vue&type=template&id=0542f288&"
import script from "./CustomThemes.vue?vue&type=script&lang=js&"
export * from "./CustomThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports